// Edição manual de valor em contrato ATIVO vira evento (spec do back
// 2026-10-09-fat-onda2a §4.3) — funções PURAS das telas Contratos e Itens.

export const TIPOS_EDICAO = [
    { valor: 'aditivo', label: 'Aditivo' },
    { valor: 'supressao', label: 'Supressão' },
    { valor: 'reajuste', label: 'Reajuste' },
];
export const rotuloTipoEdicao = (t) => (TIPOS_EDICAO.find((x) => x.valor === t) || {}).label || t || '—';

const cent = (v) => Math.round((Number(v) || 0) * 100);

// Valor Global de contrato ativo (que já era global) mudou? Implantação e afins seguem livres.
export const exigeEventoValorGlobal = (original, editando) => Boolean(
    original && editando && original.status === 'ativo' && original.tipo === 'global'
    && editando.tipo === 'global' && cent(editando.valor) !== cent(original.valor),
);

// Mesma regra do backend (tipoDaEdicao): só preço → reajuste; senão pelo sinal.
export const tipoSugerido = (antes, depois, soPreco = false) => {
    const delta = cent(depois) - cent(antes);
    if (soPreco || delta === 0) return 'reajuste';
    return delta > 0 ? 'aditivo' : 'supressao';
};

// Tipos que fazem sentido para o sinal da alteração (aditivo sobe, supressão desce).
export const tiposPermitidos = (antes, depois) => {
    const delta = cent(depois) - cent(antes);
    return TIPOS_EDICAO.filter((t) => (t.valor === 'aditivo' ? delta > 0 : t.valor === 'supressao' ? delta < 0 : true));
};

export const hojeYmd = (agora = new Date()) => {
    const p = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(agora);
    const g = (t) => p.find((x) => x.type === t).value;
    return `${g('year')}-${g('month')}-${g('day')}`;
};

export const eventoVazio = (tipo = '') => ({ tipo, data_evento: hojeYmd(), motivo: '', numero_termo: '' });
export const eventoCompleto = (ev) => Boolean(ev && String(ev.motivo || '').trim() && /^\d{4}-\d{2}-\d{2}$/.test(String(ev.data_evento || '')));

// Payload do back: tipo vazio = o backend sugere; nº do termo só quando informado.
export const payloadEvento = (ev) => ({
    motivo: String(ev.motivo || '').trim(),
    data_evento: ev.data_evento,
    ...(ev.tipo ? { tipo: ev.tipo } : {}),
    ...(String(ev.numero_termo || '').trim() ? { numero_termo: String(ev.numero_termo).trim() } : {}),
});

const CAMPO = { valor_unitario: 'valor unitário', quantidade_contratada: 'qtd. contratada' };
const fmt = (campo, v) => (campo === 'valor_unitario'
    ? Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : String(v));
export const descreverAlteracao = (a) => `${a.descricao || `Item ${a.id}`}: ${CAMPO[a.campo] || a.campo} ${fmt(a.campo, a.de)} → ${fmt(a.campo, a.para)}`;
